import React from 'react'
import { Accordion } from 'react-bootstrap'
import AccordionToggle from './accordionToggle'

const AccordionSection = ({
  title,
  children,
  defaultActive,
  expandAccordion,
  readerText,
  id,
}) => (
  <Accordion
    defaultActiveKey={
      expandAccordion ? expandAccordion : defaultActive ? '0' : null
    }
  >
    <AccordionToggle
      eventKey="0"
      defaultActive={defaultActive}
      expandAccordion={expandAccordion}
      id={id}
      readerText={readerText}
    >
      {title}
    </AccordionToggle>

    <Accordion.Collapse eventKey="0" className="expandAccordion">
      <>{children}</>
    </Accordion.Collapse>
  </Accordion>
)

export default AccordionSection
